import React from 'react'
import "./index.css"
import { DeleteIcon } from '../GlobalIcons'

const NotifyDeleteButton = ({ onClick }) => {
    return (
        <div className="notifi_delete_btn">
            <button onClick={onClick} >
                <DeleteIcon />
            </button>
        </div>
    )
}

export default NotifyDeleteButton;